export default __webpack_public_path__ + "static/concept-banner-fc7418325b48b2e6d2e19f7cfcb213a3.svg";